import React from 'react';
import './ChildList.scss';
import editIcon from '../../../assets/edit.svg';
import deleteIcon from '../../../assets/delete.svg';
import ConfirmButton from '../../utils/Confirm';

const ChildList = (props) => {
  const {
    openForm,
    deleteChild,
    childList,
    handleContinue,
    cancelRegistration,
    cancelMessage,
    maxChildrenReached = false,
    addChildLabel,
    isSubmitting = false,
  } = props;

  return (
    <div className="child-list">
      <h2 className="page-subtitle">Child information</h2>

      <div className="child-listing">
        {childList.map((child, index) => (
          <div key={index} className="child-item">
            <div className="child-field">
              <label>Child first name</label>
              <span className="value">{child.firstName}</span>
            </div>

            <div className="child-field">
              <label>Gender</label>
              <span className="value">{child.gender}</span>
            </div>

            <div className="child-date-item">
              <div className="child-field">
                <label>Month of birth</label>
                <span className="value">{child.monthOfBirth}</span>
              </div>
              <div className="child-field">
                <label>Year of birth</label>
                <span className="value">{child.yearOfBirth}</span>
              </div>
            </div>

            <div className="child-date-item">
              <div className="child-field">
                <a
                  className={`delete ${isSubmitting ? 'disabled' : ''}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (isSubmitting) return;
                    deleteChild(index);
                  }}
                >
                  <img src={deleteIcon} alt="Delete" />
                  Delete
                </a>
              </div>
              <div className="child-field">
                <a
                  className={`edit ${isSubmitting ? 'disabled' : ''}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (isSubmitting) return;
                    openForm(index, child);
                  }}
                >
                  <img src={editIcon} alt="Edit" />
                  Edit
                </a>
              </div>
            </div>
          </div>
        ))}

        {!maxChildrenReached && (
        <div className="child-listing-action">
          <button
            type="button"
            className="button secondary"
            disabled={isSubmitting}
            onClick={() => {
              if (isSubmitting) return;
              openForm(null, {});
            }}
          >
            {addChildLabel}
          </button>
        </div>)}
      </div>

      <div className="child-list-actions button-group">
        <ConfirmButton
          buttonText="Cancel"
          buttonClassName="cancel secondary"
          confirmTitle="Cancel"
          confirmMessage={cancelMessage}
          confirm={cancelRegistration}
        />

        <button
          className="button primary"
          onClick={handleContinue}
          type="button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Continue'}
        </button>
      </div>
    </div>
  );
};

export default ChildList;
